<template>
    <div :class="[`hero${body && body.hero ? body.hero.tipologia : ''}`]">
        <!--<template v-if="body && body.__risorsa__">
            <div class="emptyHero"></div>
            <div class="cont">
                <div class="innerCont">
                    <div class="titleBox">
                        <h1 class="title1">{{body.__risorsa__.genDenominazione}}</h1>
                    </div>
                </div>
            </div>
        </template>-->
        <!-- Standard -->
        <WebsiteHeroStandard v-if="body && body.hero && body.hero.tipologia == 'standard'">
            <template #background>
                <Image v-if="body.hero.cover && body.hero.cover.type.indexOf('image') > -1" :image="body.hero.cover" :width="1600" imageClass="cover" :lazyload="false" />
            </template>
            <template #content>
                <div class="breadcrumbHeroCont">
                    <OggettoBreadcrumbPill :routes="routes" />
                </div>
                <div class="heroBox" v-if="body.hero.translations[0]?.titolo || body.hero.translations[0]?.sottotitolo">
                    <h1 class="title1b">{{ body.hero.translations[0]?.titolo }}</h1>
                    <div class="subtitle" v-if="body.hero.translations[0]?.sottotitolo">
                        <p>{{ body.hero.translations[0]?.sottotitolo }}</p>
                    </div>
                </div>
            </template>
        </WebsiteHeroStandard>
        <!-- Video -->
        <WebsiteHeroStandard v-else-if="body && body.hero && body.hero.tipologia == 'video'">
            <template #background>
                <Video v-if="body.hero.video_mp4 && body.hero.video_webm && body.hero.video_mp4.type == 'video/mp4' && body.hero.video_webm.type == 'video/webm'" :videoMp4="body.hero.video_mp4" :videoWebm="body.hero.video_webm" :cover="body.hero.cover" />
            </template>
            <template #content>
                <div class="heroBox" v-if="body.hero.translations[0]?.titolo || body.hero.translations[0]?.sottotitolo">
                    <h1 class="title1b">{{ body.hero.translations[0]?.titolo }}</h1>
                    <div class="subtitle" v-if="body.hero.translations[0]?.sottotitolo">
                        <p>{{ body.hero.translations[0]?.sottotitolo }}</p>
                    </div>
                </div>
            </template>
        </WebsiteHeroStandard>
        <!-- Homepage -->
        <WebsiteHeroStandard v-else-if="body && body.hero && body.hero.tipologia == 'homepage'">
            <template #background>
                <Image v-if="body.hero.cover" :image="body.hero.cover" :width="1600" :height="560" imageClass="cover" :lazyload="false" />
            </template>
            <template #content>
                <div :class="['heroContent', { dark: body.hero.tema }]">
                    <h1 class="title1">{{ body.hero.translations[0]?.titolo }}</h1>
                    <div class="subtitle" v-if="body.hero.translations[0]?.sottotitolo">
                        <p>{{ body.hero.translations[0]?.sottotitolo }}</p>
                    </div>
                </div>
            </template>
        </WebsiteHeroStandard>
        <!-- Slideshow -->
        <WebsiteHeroSlider v-else-if="body && body.hero && body.hero.tipologia == 'slideshow'">
            <template #content>
                <swiper-slide v-for="slide in body.hero.slide">
                    <OggettoHeroSlide :card="slide.card[0]" :typename="slide.card[0].item.__typename" />
                </swiper-slide>
            </template>
        </WebsiteHeroSlider>
        <!-- Text -->
        <WebsiteHeroText v-else-if="body && body.hero && body.hero.tipologia == 'text'" :titolo="body.hero.translations[0]?.titolo" :routes="routes" />

        <div class="emptyHero" v-else></div>
    </div>
</template>

<script lang="ts" setup>
defineProps<{ body: any | null, routes: any }>()
</script>

<style lang="scss" scoped>
.headerSpace {
    height: var(--size-hero-safetop);
}

.titleBox {
    display: flex;

    h1 {
        background-color: var(--color-background-box);
        padding: var(--margin-default) var(--margin-double) var(--margin-default) var(--margin-default);
        border-radius: var(--size-header-radius);
        text-wrap: balance;
    }

    .subtitle {
        text-wrap: balance;
    }
}

.emptyHero {
    height: var(--size-hero-safetop);
}

@media screen and (max-width: 600px) {
    .emptyHero {
        height: 100px;
    }
}
</style>